const moduletemplates = {
	title: "Module Templates",
	new_moduletemplate: "New Module",
	edit_moduletemplate: "Edit Module: {name}",
	view_moduletemplate: "View Module: {name}",
	list_title: "List of Module Templates",
	list_subtitle: "Manage Module Templates",
	create_title: "Create New Module Template",
	update_title: "Update Module Template",
	details_title: "Module Template Details",
	course_form_subtitle: "Adding of course types is available in course view page.",
	id: "ID",
	name: "Name",
	description: "Description ( displayed on pdf. Keep short)",
	req_hours: "Hours",
	req_module_id: "Required Module Template",
	req_coursetemplate_id: "Required Course Template",
	type: "Type",
	template_type: "Template Type",
	price: "Price",
	price_vat: "Price VAT",
	status: "Status",
	is_included: "Is included?",
	is_joint: "Is Joint?",
	mandatory: "Mandatory",
	created_by: "Created By",
	expand_button_view_course_types: "View Course Types",
	expand_button_close_course_types: "Close",
	save_first: "Module template must be save first.",
	coursetype_id: "Course Type",
	coursetypegroup_id: "Course Type Group",
	add_to_expertise: "Adds Expertise",
	internal_note: "Internal Note",
	duplicate_message: "Do you want to create a copy of the template?",
	available_module_templates: "Available module templates",
	import_success: "Module template(s) successfully imported.",
	import_failed: "Failed to import module template(s)",
	hide_in_accomplishment: "Do not show in accomplishment",
	hide_in_enrolment: "Do not show in enrollment",
	hide_in_accomplishment_helptext: "Check this box if you would like to remove this module from the Accomplishment in the course and only use it on enrollment form.",
	required_module_course_helptext: "Here you can define the dependency between different course elements, like the order of the learning progress.",
	select_visibility: "Select visibility",
};
export default moduletemplates;